export default {
    routerName: '刊物管理',
    journal: {
        searchName: '检索条件',
        title: '标题',
        type: '类型',
        monthJournal: '月刊',
        dayJournal: '日刊',
        status: '状态',
        open: '启用',
        close: '停用',
        releaseDate: '发行时间',
        year: '年',
        month: '月',
        createTime: '创建时间',
        createStartTime: '创建开始时间',
        createEndTime: '创建结束时间',
    },
    sortButton: {
        status: '状态',
        title: '标题',
        releaseYear: '年度',
        createTime: '创建时间',
    },
    table: {
        id: 'ID',
        title: '标题',
        type: '类型',
        releaseDate: '发行时间',
        releaseYearMonthDay: '发行年月日',
        createTime: '创建时间',
        sortOrder: '排序',
        status: '状态',
    },
};
